import React, { useContext } from 'react';

import { Col, Divider, Row, Spin } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';

import IntlMessages from 'util/IntlMessages';
import { useIsMobile } from 'packages/utils';

import ReportTable from '../../ReportTable';
import GlosaryColors from '../shared/GlosaryColors';
import { mapReportData } from '../shared/mapReportData';
import GlosaryAbreviations from '../shared/GlosaryAbreviations';

import styles from '../../styles.module.less';
import { ReportContext } from '@src/containers/App/TimeTracker/Main/contexts/ReportContext';
import EditMarkDrawer from '../shared/EditMarkDrawer';
import EmptyUserData from '../shared/EmptyUserData';

export default function WorkingDayReport({
  data,
  loading = false,
  next = null,
  queriedPeriod = '',
}) {
  const { isMobile } = useIsMobile();
  const { selectedReportRecord, isDrawerOpen, setIsDrawerOpen } = useContext(ReportContext);
  if (Object.keys(data).length === 0) return null;
  return (
    <>
      <EditMarkDrawer
        isOpen={isDrawerOpen}
        setIsOpen={setIsDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        selectedRow={selectedReportRecord}
      />
      <div className="gx-w-100">
        <div className={styles.titleDt}>
          <IntlMessages id="work.direction.daily.report" />
        </div>
      </div>
      <Divider />
      <Row className="gx-mb-3" gutter={[8, 8]} align="top">
        <Col xs={24} sm={15} md={15} lg={15} xl={15}>
          <GlosaryAbreviations />
        </Col>
        <Col push={isMobile ? 0 : 1} xs={24} sm={8} md={8} lg={8} xl={8}>
          <GlosaryColors />
        </Col>
      </Row>
      {loading && <Spin />}
      <div id="scrollableDiv" className={styles.scrollableDiv}>
        <InfiniteScroll
          dataLength={data?.total ?? 0}
          scrollableTarget="scrollableDiv"
          next={next}
          hasMore={data?.hasMore}
        >
          <div className="gx-pt-4">
            {Object.keys(data?.data || {})?.length === 0 && !loading && (
              <EmptyUserData queriedPeriod={queriedPeriod} />
            )}
            {mapReportData(
              data.data,
              ({ id, employee, employer, columns, source, summary = [] }) => (
                <React.Fragment key={id}>
                  <ReportTable
                    rowKey="id"
                    data={source}
                    headerOne={employee}
                    headerTwo={employer}
                    columns={columns}
                    summaryData={summary}
                    disableScroll={true}
                  />
                </React.Fragment>
              ),
            )}
          </div>
        </InfiniteScroll>
      </div>
    </>
  );
}
